export {default} from './FAQS'
